export function initHistories() {
    document.querySelectorAll('.history:not([data-history-init])').forEach(section => {
        section.setAttribute('data-history-init', '1');

        const items = Array.from(section.querySelectorAll('.history__item'));
        if (!items.length) return;

        section.style.setProperty('--history-count', items.length);

        let currentIndex = -1;

        function showItem(i) {
            if (i === currentIndex) return;
            currentIndex = i;

            items.forEach((item, idx) => {
                if (idx === i) {
                    item.classList.add('is-active');
                    item.classList.remove('is-past');
                } else if (idx < i) {
                    item.classList.remove('is-active');
                    item.classList.add('is-past');
                } else {
                    item.classList.remove('is-active', 'is-past');
                }
            });
        }

        showItem(0);

        function onScroll() {
            const rect = section.getBoundingClientRect();
            const scrollRange = section.offsetHeight - window.innerHeight;
            if (scrollRange <= 0) return;
            const progress = -rect.top / scrollRange;
            const clamped = Math.max(0, Math.min(1 - 1e-9, progress));
            showItem(Math.floor(clamped * items.length));
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    });
}
